import axios from 'axios';

export function getAdminAdDisplayLogs(token, params) {
    return axios.get(`${process.env.REACT_APP_API_URL}/admin/adDisplayLogs`, {
        headers: { Authorization: token },
        params: params || {}
    });
}
